module.exports = __webpack_public_path__ + "media/packs/assets/images/concepts/ja/p3-0f07853a791fd1676713a006a1dcf64a.png";